import React from 'react';
import { useCupidoLogin } from '../../helpers/hooks';
import Logo from '../../elements/Logo';

interface RegisterPromoProps {
  closeModal: () => void
}

export default function RegisterPromo(props: RegisterPromoProps) {

  const { closeModal } = props;
  const { instance, handleLogin } = useCupidoLogin();

  return (
    <div className="flex flex-col justify-center items-center z-50">
      {/* Logo */}
      <div className="h-20 mb-16">
        <Logo />
      </div>
      <div style={{ maxWidth: 1024 }} className="flex flex-col justify-center items-center">
        <h3 style={{ maxWidth: 900 }} className="font-extrabold text-4xl">
          Join Nucleo and get full access to all the content, services, and features
        </h3>

        <span className="pt-4 text-neutral-500 text-lg text-center">
          Take advantage of the 2026 Free Trial. Currently 1400+ accounts are served via our Technology.
        </span>

        <div className="flex flex-col items-center mt-12 w-full max-w-xs gap-4">
          <button
            type="button"
            onClick={() => {
              closeModal();
              handleLogin(instance);
            }}
            className="w-full p-4 border border-main-600 rounded-md bg-main-600 text-base font-semibold text-white transition-colors hover:bg-main-700"
          >
            Register with email
          </button>

          <button
            type="button"
            onClick={() => {
              closeModal();
              handleLogin(instance, 'google.com');
            }}
            className="w-full p-4 border border-neutral-300 rounded-md bg-white text-base font-semibold text-neutral-700 transition-colors hover:bg-neutral-50"
          >
            Register with Google
          </button>

          <button
            type="button"
            onClick={() => {
              closeModal();
              handleLogin(instance, 'linkedin.com');
            }}
            className="w-full p-4 border border-neutral-300 rounded-md bg-white text-base font-semibold text-neutral-700 transition-colors hover:bg-neutral-50"
          >
            Register with Linkedin
          </button>
        </div>
      </div>
    </div>
  );
}
